
angular
  .module('core.auth')
  .factory('AuthService', ['$window', '$cookies', '$resource', '$location', 'envService', ($window, $cookies, $resource, $location, envService) => {
    const authService = {};
    authService.validateAuthenticationIfNeeded = () => {
      if (!authService.isAuthenticated()) {
        return;
      }
      const APIURL = envService.read('apiUrl');
      const loginMember = JSON.parse($cookies.get('user'));
      $resource(`${APIURL}/admin/adminuser/${loginMember.USER_ID}`).get({}, (data) => {
        console.log(data);
        if (data.user) {
          $cookies.put('user', JSON.stringify(data.user));
          if (loginMember.LEVEL !== data.user.LEVEL) {
            $window.location.reload();
          }
          return;
        }
        $cookies.remove('token');
        $cookies.remove('user');
        $location.path('/login');
      }, () => {
        $cookies.remove('token');
        $cookies.remove('user');
        $location.path('/login');
      });
    };
    authService.isAuthenticated = () => !(!$cookies.get('token') || !$cookies.get('user'));
    authService.isLevel2Authenticated = () => {
      const user = $cookies.get('user');
      if (user) {
        const userDic = JSON.parse(user);
        const level = parseInt(userDic.LEVEL, 10);
        return level >= 2;
      }
      return false;
    };
    /** App Setting screens: editable if logged in and not CS-only (LEVEL >= 99). */
    authService.canEditAppSettings = () => {
      if (!authService.isAuthenticated()) return false;
      const user = $cookies.get('user');
      if (!user) return false;
      try {
        const level = parseInt(JSON.parse(user).LEVEL, 10);
        if (!Number.isFinite(level)) return true;
        return level < 99;
      } catch (e) {
        return true;
      }
    };
    authService.loginMember = () => {
      const user = $cookies.get('user');
      if (user) {
        return JSON.parse(user);
      }
      return null;
    };
    return authService;
  }]);

angular
  .module('core.auth')
  .factory('authInterceptor', ['$cookies', function authInterceptor($cookies, $rootScope, $cookieStore, $q) {
    return {
      request(config) {
        config.headers = config.headers || {};
        const token = $cookies.get('token');
        if (token) {
          config.headers.Authorization = `Baerer ${token}`;
        }
        const user = $cookies.get('user');
        if (user) {
          config.headers['IW-COUNTRY-CODE'] = JSON.parse(user).COUNTRY_CODE || 'KR';
        }
        return config;
      },
      response(response) {
        return response || $q.when(response);
      },
    };
  }]);

angular
  .module('core.auth')
  .config(($httpProvider) => {
    $httpProvider.interceptors.push('authInterceptor');
  });



// WEBPACK FOOTER //
// ./src/app/core/auth/auth.service.js